(function () {
  'use strict';

  if (!document.body.classList.contains('product')) return;

  var checkoutBusy = false;
  var checkoutBusyUntil = 0;
  var blockRedirect = false;
  var redirectBlockUntil = 0;
  var checkoutOpenedAt = 0;
  var guardedHref = window.location.href;

  var isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  function isShiprocketFallbackUrl(url) {
    try {
      var target = new URL(url, window.location.href);
      if (target.origin !== window.location.origin) return false;

      if (target.pathname.indexOf('/cart') === 0) return true;
      if (target.pathname.indexOf('/checkout') === 0) return true;
      if (
        target.pathname === window.location.pathname &&
        target.search === window.location.search
      ) {
        return true;
      }

      return false;
    } catch (err) {
      return false;
    }
  }

  function shouldBlockRedirect(url) {
    if (!blockRedirect && Date.now() > redirectBlockUntil) return false;
    return isShiprocketFallbackUrl(url);
  }

  function setRedirectBlock(active, durationMs) {
    blockRedirect = !!active;
    guardedHref = window.location.href;

    if (active) {
      redirectBlockUntil = Date.now() + (durationMs || 15000);
    } else {
      redirectBlockUntil = 0;
    }
  }

  function markCheckoutBusy(ms) {
    checkoutBusy = true;
    checkoutBusyUntil = Date.now() + (ms || 900);
    window.setTimeout(function () {
      if (Date.now() >= checkoutBusyUntil) {
        checkoutBusy = false;
      }
    }, ms || 900);
  }

  function isCheckoutBusy() {
    return checkoutBusy && Date.now() < checkoutBusyUntil;
  }

  function patchLocationRedirect() {
    var assign = window.location.assign.bind(window.location);
    var replace = window.location.replace.bind(window.location);

    window.location.assign = function (url) {
      if (shouldBlockRedirect(url)) return;
      return assign(url);
    };

    window.location.replace = function (url) {
      if (shouldBlockRedirect(url)) return;
      return replace(url);
    };

    function wrapHrefSetter(set) {
      return function (url) {
        if (shouldBlockRedirect(url)) return;
        return set.call(this, url);
      };
    }

    try {
      var proto = window.Location && window.Location.prototype;
      var protoDescriptor = proto && Object.getOwnPropertyDescriptor(proto, 'href');

      if (protoDescriptor && protoDescriptor.set) {
        Object.defineProperty(proto, 'href', {
          configurable: true,
          enumerable: protoDescriptor.enumerable,
          get: protoDescriptor.get,
          set: wrapHrefSetter(protoDescriptor.set),
        });
      }

      var instanceDescriptor = Object.getOwnPropertyDescriptor(window.location, 'href');
      if (instanceDescriptor && instanceDescriptor.set) {
        Object.defineProperty(window.location, 'href', {
          configurable: true,
          enumerable: true,
          get: function () {
            return instanceDescriptor.get.call(window.location);
          },
          set: wrapHrefSetter(instanceDescriptor.set),
        });
      }
    } catch (err) {
      /* iOS WebKit often blocks location.href redefinition */
    }
  }

  function initIOSRedirectWatchdog() {
    if (!isIOS) return;

    window.setInterval(function () {
      var currentHref = window.location.href;

      if (!blockRedirect && Date.now() > redirectBlockUntil) {
        guardedHref = currentHref;
        return;
      }

      if (currentHref !== guardedHref && isShiprocketFallbackUrl(currentHref)) {
        history.replaceState(null, '', guardedHref);
        return;
      }

      if (!isShiprocketFallbackUrl(currentHref)) {
        guardedHref = currentHref;
      }
    }, 100);
  }

  function watchCheckoutContainer() {
    var observer = new MutationObserver(function () {
      var checkoutOpen = !!document.getElementById('fastrr-main-container');
      setRedirectBlock(checkoutOpen, checkoutOpen ? 30000 : 0);

      if (document.getElementById('headless-iframe') && !checkoutOpenedAt) {
        checkoutOpenedAt = Date.now();
      }

      if (!checkoutOpen) {
        checkoutOpenedAt = 0;
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initIOSPopstateGuard() {
    if (!isIOS) return;

    window.addEventListener(
      'popstate',
      function (event) {
        if (!document.getElementById('headless-iframe')) return;
        if (!checkoutOpenedAt || Date.now() - checkoutOpenedAt > 5000) return;

        event.stopImmediatePropagation();
        history.pushState(null, '', window.location.href);
      },
      true
    );
  }

  function clearCheckoutUiBlockers() {
    document.body.classList.remove('pincode-modal-open');

    var spinner = document.getElementById('ph-nav-spinner');
    if (spinner) {
      spinner.classList.remove('is-visible');
      spinner.hidden = true;
      spinner.setAttribute('aria-hidden', 'true');
    }

    document.documentElement.classList.remove('ph-nav-loading');
  }

  function prepareBodyForCheckout() {
    clearCheckoutUiBlockers();

    if (!isIOS) {
      document.body.style.overflow = '';
      document.body.style.height = '';
      document.querySelectorAll('sticky-add-cart').forEach(function (sticky) {
        if (sticky.classList.contains('ph-sticky-always')) return;
        sticky.classList.remove('show-sticky-cart');
      });
    }
  }

  function resetStaleCheckout() {
    var iframe = document.getElementById('headless-iframe');
    var container = document.getElementById('fastrr-main-container');

    if (!container || iframe) return;

    container.remove();

    if (!isIOS) {
      document.body.style.overflow = '';
      document.body.style.height = '';
    }
  }

  function enableVariantInputs() {
    document.querySelectorAll('form[data-type="add-to-cart-form"] [name="id"]').forEach(function (input) {
      input.disabled = false;
    });
  }

  function ensureQuantityInput(form) {
    if (!form) return;

    var quantityInput = form.querySelector('[name="quantity"]');
    if (quantityInput) return;

    var hiddenQuantity = document.createElement('input');
    hiddenQuantity.type = 'hidden';
    hiddenQuantity.name = 'quantity';
    hiddenQuantity.value = '1';
    form.appendChild(hiddenQuantity);
  }

  function syncFormsBeforeCheckout(source) {
    enableVariantInputs();

    var form = getProductForm(source);
    if (!form) return;

    ensureQuantityInput(form);

    if (typeof window.phSyncPickleChoice === 'function') {
      window.phSyncPickleChoice();
    }

    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) return;

    document.querySelectorAll('form[data-type="add-to-cart-form"] [name="id"]').forEach(function (input) {
      input.value = variantInput.value;
      input.disabled = false;
    });
  }

  function getVisibleShiprocketButton() {
    var buttons = document.querySelectorAll(
      '.shiprocket-headless[data-type="product"] .sr-headless-checkout'
    );

    for (var i = 0; i < buttons.length; i += 1) {
      var button = buttons[i];
      if (button.offsetParent !== null && !button.disabled) {
        return button;
      }
    }

    return null;
  }

  function getCheckoutButton(source) {
    if (source && source.classList) {
      if (source.classList.contains('sticky-shiprocket-trigger')) {
        return source;
      }

      if (source.classList.contains('sr-headless-checkout')) {
        return source;
      }
    }

    if (source && source.closest) {
      var stickyTrigger = source.closest('.sticky-shiprocket-trigger');
      if (stickyTrigger) return stickyTrigger;

      var shiprocketBtn = source.closest('.sr-headless-checkout');
      if (shiprocketBtn) return shiprocketBtn;
    }

    return getVisibleShiprocketButton();
  }

  function getProductForm(source) {
    if (source && source.closest) {
      var fromSource = source.closest('form[data-type="add-to-cart-form"]');
      if (fromSource) return fromSource;
    }

    var checkoutButton = getCheckoutButton(source);
    if (checkoutButton && checkoutButton.closest) {
      var fromButton = checkoutButton.closest('form[data-type="add-to-cart-form"]');
      if (fromButton) return fromButton;
    }

    return (
      document.querySelector('.product-detail__buy-buttons form[data-type="add-to-cart-form"]') ||
      document.querySelector('sticky-add-cart form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]')
    );
  }

  function requiresPhoneVerification() {
    return !!document.querySelector('[data-gurugram-verification]');
  }

  function isPhoneVerified() {
    return window.__phGurugramPhoneVerified === true;
  }

  function buildCheckoutEvent(button, originalEvent) {
    var target = (originalEvent && originalEvent.target) || button;

    return {
      preventDefault: function () {
        if (originalEvent) originalEvent.preventDefault();
      },
      stopPropagation: function () {
        if (originalEvent) originalEvent.stopPropagation();
      },
      stopImmediatePropagation: function () {
        if (originalEvent) originalEvent.stopImmediatePropagation();
      },
      currentTarget: button,
      target: target,
      type: 'click',
    };
  }

  function waitForShiprocket(callback, maxAttempts) {
    return new Promise(function (resolve, reject) {
      var attempts = 0;
      var limit = maxAttempts || 100;

      var timer = setInterval(function () {
        attempts += 1;

        if (callback()) {
          clearInterval(timer);
          resolve();
          return;
        }

        if (attempts >= limit) {
          clearInterval(timer);
          reject(new Error('Shiprocket checkout is not ready.'));
        }
      }, 100);
    });
  }

  function invokeShiprocketCheckout(button, originalEvent) {
    var checkoutEvent = buildCheckoutEvent(button, originalEvent);

    if (
      window.shiprocketCheckoutEvents &&
      typeof window.shiprocketCheckoutEvents.buyProduct === 'function'
    ) {
      window.shiprocketCheckoutEvents.buyProduct(checkoutEvent);
      return true;
    }

    if (typeof window.shiprocketCheckoutBuyProductHandler === 'function') {
      window.shiprocketCheckoutBuyProductHandler(checkoutEvent);
      return true;
    }

    return false;
  }

  async function startCheckout(source, originalEvent) {
    if (isCheckoutBusy()) return;

    markCheckoutBusy(900);

    try {
      if (requiresPhoneVerification() && !isPhoneVerified()) {
        document.dispatchEvent(new CustomEvent('ph:checkout-blocked'));
        return;
      }

      clearCheckoutUiBlockers();
      syncFormsBeforeCheckout(source);
      setRedirectBlock(true, 30000);

      var checkoutButton = getCheckoutButton(source);
      if (!checkoutButton) {
        throw new Error('Buy Now button is not ready yet.');
      }

      var form = getProductForm(checkoutButton);
      if (!form) {
        throw new Error('Product form not found.');
      }

      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) {
        throw new Error('Product variant is missing.');
      }

      var pickleValue = typeof window.phGetPickleChoice === 'function' ? window.phGetPickleChoice() : '';
      if (pickleValue) {
        var quantityInput = form.querySelector('[name="quantity"]');
        var quantity = quantityInput && quantityInput.value ? quantityInput.value : '1';
        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: Number(variantInput.value),
            quantity: Number(quantity),
            properties: {
              'Pickle flavour': pickleValue,
            },
          }),
        });
        setRedirectBlock(false);
        var checkoutEvent = buildCheckoutEvent(checkoutButton, originalEvent || null);
        if (
          window.shiprocketCheckoutEvents &&
          typeof window.shiprocketCheckoutEvents.buyCart === 'function'
        ) {
          window.shiprocketCheckoutEvents.buyCart(checkoutEvent);
          return;
        }
        window.location.href = '/checkout';
        return;
      }

      if (!invokeShiprocketCheckout(checkoutButton, originalEvent || null)) {
        await waitForShiprocket(function () {
          return invokeShiprocketCheckout(checkoutButton, originalEvent || null);
        });
      }
    } catch (err) {
      console.error('[shiprocket-checkout-fix]', err);
      setRedirectBlock(false);
      document.dispatchEvent(
        new CustomEvent('ph:checkout-error', {
          detail: { message: 'Unable to start checkout. Please try again.' },
        })
      );
    }
  }

  function isCheckoutClickTarget(target) {
    return !!(
      target &&
      (target.closest('.sr-headless-checkout') ||
        target.closest('.sticky-shiprocket-trigger') ||
        target.closest('.shiprocket-headless[data-type="product"]'))
    );
  }

  function blockUnverifiedCheckout(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    document.dispatchEvent(new CustomEvent('ph:checkout-blocked'));
  }

  function handleCheckoutClick(event, source) {
    if (isCheckoutBusy()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    var checkoutTarget =
      source ||
      event.target.closest('.sr-headless-checkout') ||
      event.target.closest('.sticky-shiprocket-trigger');

    if (!checkoutTarget) return;

    if (requiresPhoneVerification() && !isPhoneVerified()) {
      blockUnverifiedCheckout(event);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (checkoutTarget.classList.contains('sticky-shiprocket-trigger')) {
      var visibleBtn = getVisibleShiprocketButton();
      if (visibleBtn) {
        startCheckout(visibleBtn, event);
        return;
      }
    }

    startCheckout(checkoutTarget, event);
  }

  function neutralizeShiprocketButton(button) {
    if (!button || button.dataset.phCheckoutFixed === 'true') return;

    button.removeAttribute('onclick');
    button.dataset.phCheckoutFixed = 'true';
    simplifyStickyShiprocketButton(button);
  }

  function simplifyStickyShiprocketButton(button) {
    if (!button || !button.closest('.ph-shiprocket-sticky--text-only')) return;
    if (button.dataset.phStickySimplified === 'true') return;

    button.dataset.phStickySimplified = 'true';
    button.style.display = 'flex';
    button.style.alignItems = 'center';
    button.style.justifyContent = 'center';
    button.style.overflow = 'hidden';
    button.style.width = '100%';
    button.style.gap = '0';

    button.querySelectorAll('img, .sr-powered-by, .sr-checkout-visible1, .sr-pl-15').forEach(function (node) {
      node.style.display = 'none';
    });

    var paymentIcons = button.querySelector('.sr-checkout-visible:not(.sr-checkout-visible2)');
    if (paymentIcons) {
      paymentIcons.style.display = 'none';
    }

    button.style.backgroundColor = '#e5792f';
    button.style.color = '#fff';

    var textEl = button.querySelector('.sr-checkout-visible2');
    if (textEl) {
      textEl.textContent = 'Buy Now';
      textEl.style.display = 'block';
      textEl.style.fontSize = '15px';
      textEl.style.fontWeight = '600';
      textEl.style.textTransform = 'none';
      textEl.style.whiteSpace = 'nowrap';
      textEl.style.letterSpacing = '-0.02em';
      textEl.style.color = '#fff';
    }
  }

  function scanShiprocketButtons() {
    document.querySelectorAll('.sr-headless-checkout').forEach(neutralizeShiprocketButton);
  }

  function prewarmShiprocket() {
    if (window.location.pathname.indexOf('/products/') !== 0) return;

    fetch(window.location.pathname + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).catch(function () {});

    window.setInterval(function () {
      if (document.getElementById('fastrr-main-container')) return;

      document.querySelectorAll('.sr-headless-checkout[disabled]').forEach(function (button) {
        button.disabled = false;
        button.removeAttribute('disabled');
      });
    }, 1500);
  }

  function initCheckoutInterceptor() {
    scanShiprocketButtons();

    var buttonObserver = new MutationObserver(function () {
      scanShiprocketButtons();
    });
    buttonObserver.observe(document.body, { childList: true, subtree: true });

    document.addEventListener(
      'click',
      function (event) {
        if (!isCheckoutClickTarget(event.target)) return;
        handleCheckoutClick(event);
      },
      true
    );
  }

  function initStickyCheckoutVisibility() {
    var sticky = document.querySelector('sticky-add-cart');
    var mainShiprocket = document.querySelector('.ph-shiprocket-main');
    if (!sticky || !mainShiprocket) return;

    function updateVisibility() {
      var stickyVisible =
        sticky.classList.contains('show-sticky-cart') ||
        sticky.classList.contains('ph-sticky-always');
      var fallback = mainShiprocket.parentElement
        ? mainShiprocket.parentElement.querySelector('.ph-shiprocket-fallback')
        : null;
      var hideMain = stickyVisible ? 'none' : '';

      mainShiprocket.style.display = hideMain;
      if (fallback && fallback.hidden === false) {
        fallback.style.display = hideMain === 'none' ? 'none' : '';
      }
    }

    var observer = new MutationObserver(updateVisibility);
    observer.observe(sticky, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    updateVisibility();
  }

  function initMobileCheckoutVisibility() {
    initStickyCheckoutVisibility();
  }

  function initStickyCheckoutFallback() {
    document.querySelectorAll('sticky-add-cart .btn-checkout-dynamic').forEach(function (wrap) {
      var stickyShiprocket = wrap.querySelector('.ph-shiprocket-sticky');
      var fallback = wrap.querySelector('.ph-sticky-checkout-fallback');
      if (!stickyShiprocket || !fallback) return;

      function hideFallback() {
        fallback.hidden = true;
        fallback.style.display = 'none';
      }

      function syncFallback() {
        if (stickyShiprocket.querySelector('.sr-headless-checkout')) {
          hideFallback();
        }
      }

      var observer = new MutationObserver(syncFallback);
      observer.observe(stickyShiprocket, { childList: true, subtree: true });
      window.addEventListener('resize', syncFallback);
      syncFallback();
    });
  }

  function initMainCheckoutFallback() {
    document.querySelectorAll('.btn-checkout-dynamic').forEach(function (wrap) {
      var main = wrap.querySelector('.ph-shiprocket-main');
      var fallback = wrap.querySelector('.ph-shiprocket-fallback');
      if (!main || !fallback) return;

      function hideFallback() {
        fallback.hidden = true;
        fallback.style.display = 'none';
      }

      function showFallback() {
        if (main.querySelector('.sr-headless-checkout')) return;
        fallback.hidden = false;
        fallback.style.display = '';
      }

      function syncFallback() {
        if (main.querySelector('.sr-headless-checkout')) {
          hideFallback();
        }
      }

      var observer = new MutationObserver(syncFallback);
      observer.observe(main, { childList: true, subtree: true });
      syncFallback();
      [800, 2000, 5000].forEach(function (delay) {
        window.setTimeout(showFallback, delay);
      });
      window.addEventListener('load', function () {
        window.setTimeout(showFallback, 600);
      });
    });
  }

  patchLocationRedirect();
  initIOSRedirectWatchdog();
  watchCheckoutContainer();
  initIOSPopstateGuard();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      resetStaleCheckout();
      prewarmShiprocket();
      initMobileCheckoutVisibility();
      initStickyCheckoutFallback();
      initMainCheckoutFallback();
      initCheckoutInterceptor();
    });
  } else {
    resetStaleCheckout();
    prewarmShiprocket();
    initMobileCheckoutVisibility();
    initStickyCheckoutFallback();
    initMainCheckoutFallback();
    initCheckoutInterceptor();
  }
})();
